import script from "./AgeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./AgeSwitch.vue?vue&type=style&index=0&id=6ddbe54f&scoped=true&lang=css"

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddbe54f"]])

export default __exports__